export const COOKIE_NAMES: any = {
    TOKEN : 'meta-token',
    PUBLIC_TOKEN : 'meta-public-token',
    WORKSPACE: 'meta-workspace',
    OIDC: 'meta-oidc',
    AFTER_SIGN_IN: 'meta-after-sign-in',
};

export const AiResultDisplayInterval: number = 300;

export const colors = [
    'palette-purple-light',
    'palette-blue-light',
    'palette-green-light',
    'palette-teal-light',
    'palette-yellow-light',
    'palette-red-light',
    'palette-grey-light',
    'palette-purple-dark',
    'palette-blue-dark',
    'palette-green-dark',
    'palette-teal-dark',
    'palette-yellow-dark',
    'palette-red-dark',
    'palette-grey-dark'
];

export enum HelpWidgetType {
    FEEDBACK = 'FEEDBACK',
    FEATURE = 'FEATURE',
    SCREEN = 'SCREEN',
    DASHBOARD = 'DASHBOARD',
    GENERAL = 'GENERAL',
    ONBOARDING = 'ONBOARDING',
    APPLICATIONDETAILS = 'APPLICATIONDETAILS',
    ESTIMATION = 'ESTIMATION',
}

export enum KeyboardKey {
    ARROW_UP = 'ArrowUp',
    ARROW_DOWN = 'ArrowDown',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_RIGHT = 'ArrowRight',
    ENTER = 'Enter',
    ESCAPE = 'Escape',
    BACKSPACE = 'Backspace',
}

export enum AiMethods {
    USER_STORY = 'User Story',
    ACCEPTANCE_CRITERIA = 'Acceptance Criteria',
    FEATURE_USE_CASE = 'Use Case'
}

export enum AiMethodsLowCase {
    USER_STORY = 'userStory',
    ACCEPTANCE_CRITERIA = 'acceptanceCriteria',
    FEATURE_USE_CASE = 'useCase'
}

export enum GenerationAIType {
    USER_STORY = 'USER_STORY_',
    USER_STORY_BDD_SCENARIOS = 'USER_STORY_BDD_SCENARIOS',
    ACCEPTANCE_CRITERIA = 'ACCEPTANCE_CRITERIA_',
    FEATURE_USE_CASE = 'FEATURE_USE_CASE'
}



